;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "jiv7Lhutpf"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="jiv7Lhutpf"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/PlbOpSmr4nJv3ig9/content-1/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "Pw4AXS6Gnp"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _this = jQuery(this),
      counter = _this.find('.lh-counter-number'),
			time = section.settings.time;

		if(time.indexOf('s') != -1){
			var time_out = time.replace('s', '');
			time_out = time_out*1000;
		}

  function startCounter(){
    counter.each(function() {
    var $this = $(this),
        countTo = $this.attr('data-number');
        $this.text(0);
    $({ countNum: $this.text()}).animate({
      countNum: countTo
      },
      {
        duration: time_out,
        easing:'linear',
        step: function() {
          $this.text(setNumber($this,this.countNum));
        },
        complete: function() {
          $this.text(setNumber($this,this.countNum));
        }

      });
    });
  }
  function setNumber($this,num){
    var show_number = $this.data('fullNumber') == 'yes';
    var rs = Math.floor(num);
    if(!show_number){
      //   rs = (rs >= 1000) ? (Math.floor(rs / 1000) + "k" + ((rs % 1000 != 0) ? "+": "")) : rs;
      rs = (rs >= 1000000000) ? ( Math.floor(rs / 1000000000) + "b" + ((rs % 1000000000 != 0) ? "+": "") ) : (rs >= 1000000) ? (Math.floor(rs / 1000000) + "m" + ((rs % 1000000 != 0) ? "+": "")) : (rs >= 1000) ? (Math.floor(rs / 1000) + "k" + ((rs % 1000 != 0) ? "+": "")) : rs;
    }
    return rs;
  }
  function isAnyPartOfElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
}
  $(window).on('scroll resize',function(){
    if(isAnyPartOfElementInViewport(counter[0])){
      startCounter();
      $(window).off('scroll resize');
    }
  }).trigger('scroll');
 };						cb.bind($('section[data-section-id="Pw4AXS6Gnp"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="Pw4AXS6Gnp"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/PlbOpSmr4nJv3ig9/counter/",						settings: {"time":"1s"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "uPEQ0cw2XM"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="uPEQ0cw2XM"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/PlbOpSmr4nJv3ig9/content-2/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "rq2dfwgl82o"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let left = $(this).find('.lh-left .lh-item');
  let right = $(this).find('.lh-right .lh-item');

  let removeAllActive = function(dom, contents) {
    dom.each( function(i) {
      let hasClass = this.classList.contains('active');
      if(hasClass) {
        this.classList.remove('active');
        contents[i].style.maxHeight = `0`;
      }
    });
  }

  let eventAc = function(dom) {
    dom.each( function(i) {
      this.addEventListener('click', () => {
        console.log('click');
        let contents = dom.find('.lh-content');
        let currentHasAc = this.classList.contains('active');
        if(!currentHasAc) {
          removeAllActive(dom, contents);
          this.classList.add('active');
          contents[i].style.maxHeight = `${contents[i].scrollHeight}px`
        }
      })
    })
  }
  eventAc(left);
  eventAc(right);

 };						cb.bind($('section[data-section-id="rq2dfwgl82o"] include[data-name="style_1"][data-id="1"]').get(0))(jQuery);;var cb  = function($) {

$(this).find('.lh-accordion-item .lh-header').on('click', function() {
    var _this = jQuery(this).closest('.lh-accordion-item');
    _this.addClass('active');
    _this.siblings('.active').removeClass('active');
});

 };						cb.bind($('section[data-section-id="rq2dfwgl82o"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="rq2dfwgl82o"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/A86iQazbFCg9LR3W/faqs/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');